import { fetchObjectMetadata } from '../network/common.api';
import {
    SET_OBJECT_METADATA_LOADING,
    SET_OBJECT_METADATA_DATA,
} from '../reducers/redux-constants';

export const loadObjectMetadata = (
    objectType: string,
    sendCustomFieldsOnly: boolean = true,
) => async (dispatch: any, getState: any) => {
    const { genericPage } = getState();

    if (genericPage?.objectMetadataLoading || genericPage?.objectMetadata?.[objectType]) {
        return;
    }

    dispatch({ type: SET_OBJECT_METADATA_LOADING, data: true });

    const response = await fetchObjectMetadata({ objectType, sendCustomFieldsOnly });

    if (response.isSuccess && response.data) {
        dispatch({
            type: SET_OBJECT_METADATA_DATA,
            data: { [objectType]: response.data },
        });
    }

    dispatch({ type: SET_OBJECT_METADATA_LOADING, data: false });
};
